import React, { useState } from 'react';
import { resendVerification } from '../services/api';
import { useAuth } from '../context/AuthContext';
import './VerificationBanner.css';

function VerificationBanner() {
  const { user } = useAuth();
  const [status, setStatus] = useState('idle'); // idle | sending | sent | error
  const [dismissed, setDismissed] = useState(false);

  if (!user || user.emailVerified || dismissed) return null;

  const handleResend = async () => {
    setStatus('sending');
    try {
      await resendVerification();
      setStatus('sent');
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="verification-banner">
      <span className="verification-banner-icon">✉️</span>
      <span className="verification-banner-text">
        Please verify your email address. Check your inbox at <strong>{user.email}</strong>.
      </span>
      <div className="verification-banner-actions">
        {status === 'sent' ? (
          <span className="verification-banner-sent">Email sent!</span>
        ) : (
          <button
            className="verification-banner-resend"
            onClick={handleResend}
            disabled={status === 'sending'}
          >
            {status === 'sending' ? 'Sending…' : 'Resend email'}
          </button>
        )}
        {status === 'error' && (
          <span className="verification-banner-error">Failed to send. Try again.</span>
        )}
        <button className="verification-banner-dismiss" onClick={() => setDismissed(true)} aria-label="Dismiss">×</button>
      </div>
    </div>
  );
}

export default VerificationBanner;
